export const POPUP_ACTIONS = {
    INIT: 'POPUP/INIT',
    OPEN: 'POPUP/OPEN',
    LOAD_CONFIG: 'POPUP/LOAD_CONFIG',
    CLOSE: 'POPUP/CLOSE',
    CLOSED: 'POPUP/CLOSED',
    SWITCH: 'POPUP/SWITCH'
};
